/** `GET /tour_operators/{top_id}/catalog_pickers/{kind}/` — the catalog record editors'
 *  pickers (plan O14), gated by the CATALOG permissions rather than `tour_pickers/`'s
 *  `console_tours_view`: an activity or itinerary manager without tour permissions picks
 *  from here.
 *
 *  Each kind lists what the record's write accepts for that field, by name then id:
 *  `categories` (rows add `icon`) and `activities` (`q` matches the name or the display
 *  name) for the activity record; `line_sets`, `cta_tours`, `regions`, `trip_types` (rows add
 *  `tenant`: the operator or its franchise parent) and `tags` for the itinerary; `atags`
 *  (the operator's access tags and its franchise parent's) for both. */
import type { AxiosRequestConfig } from 'axios';

import { apiGet } from './client';
import type { components, paths } from './types';

export type CatalogPickerKind =
  paths['/tour_operators/{top_id}/catalog_pickers/{kind}/']['get']['parameters']['path']['kind'];

export type CatalogPickerList = components['schemas']['ConsoleCatalogPickerList'];
export type CatalogPickerOption = CatalogPickerList['results'][number];

export function catalogPicker(
  tourOperatorId: number,
  kind: CatalogPickerKind,
  {
    q,
    limit,
    signal,
  }: { q?: string; /** Default 50, at most 200. */ limit?: number; signal?: AbortSignal } = {},
): Promise<CatalogPickerList> {
  const params = new URLSearchParams();
  const query = q?.trim();
  if (query) params.set('q', query);
  if (limit !== undefined) params.set('limit', String(limit));
  const qs = params.toString();
  const config: AxiosRequestConfig | undefined = signal ? { signal } : undefined;
  return apiGet<CatalogPickerList>(
    `/tour_operators/${tourOperatorId}/catalog_pickers/${kind}/${qs ? `?${qs}` : ''}`,
    config,
  );
}
